/* Leagues Cup 2026: touch scroll performance
   Keeps the main thread free so the FIRST swipe always registers on iOS/Android.
   1) Pauses CSS animations (marquees, carousels) while they are off-screen.
   2) Pauses every animation while the tab/page is hidden.
   3) Kills the hero parallax rAF on touch devices (it repaints the whole viewport).
   4) Marks long sections with .lc-cv so the browser can skip off-screen render work.
   No visual change when everything is on-screen. */
(function () {
  "use strict";

  var isTouch =
    (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) ||
    "ontouchstart" in window;

  /* ---------- 1. Pause off-screen animation bands ---------- */
  function gateAnimations() {
    if (!("IntersectionObserver" in window)) return;

    var bands = document.querySelectorAll(
      ".marquee-pause, .cc-section, .rivals-viewport, [data-anim-band]"
    );
    if (!bands.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          e.target.classList.toggle("lc-anim-idle", !e.isIntersecting);
        }
      },
      { rootMargin: "120px 0px" }
    );

    for (var i = 0; i < bands.length; i++) {
      bands[i].classList.add("lc-anim-idle");
      io.observe(bands[i]);
    }
  }

  /* ---------- 2. Freeze everything when the page is backgrounded ---------- */
  function gateVisibility() {
    document.addEventListener(
      "visibilitychange",
      function () {
        document.documentElement.classList.toggle(
          "lc-page-hidden",
          document.hidden
        );
      },
      { passive: true }
    );
  }

  /* ---------- 3. Neutralise hero parallax on touch ---------- */
  function killTouchParallax() {
    if (!isTouch) return;
    var items = document.querySelectorAll("[data-parallax]");
    for (var i = 0; i < items.length; i++) {
      items[i].removeAttribute("data-parallax");
      items[i].style.transform = "";
      items[i].style.willChange = "auto";
    }
  }

  /* ---------- 4. Off-screen render skipping for tall sections ---------- */
  function markContainable() {
    if (!("CSS" in window) || !CSS.supports || !CSS.supports("content-visibility", "auto")) return;
    var secs = document.querySelectorAll("main > .shopify-section");
    /* Skip the first two sections (above the fold) so nothing pops on load. */
    for (var i = 2; i < secs.length; i++) {
      var s = secs[i];
      if (s.querySelector("[data-no-cv]")) continue;
      s.classList.add("lc-cv");
    }
  }

  /* ---------- 5. Safety net: never leave the page in a scroll-locked state ----------
     Overlays (cart drawer, waitlist modal, intro gate) lock body scroll. If one of
     them is restored from bfcache or errors out mid-close, the lock can survive and
     scrolling looks completely dead. This re-checks and clears any orphan lock. */
  function unstickScroll() {
    var gate = document.getElementById("lc-intro-gate");
    var gateOpen = !!(gate && gate.classList.contains("lc-ig-open"));
    if (!gateOpen) document.documentElement.classList.remove("lc-ig-locked");

    /* NOTE: the cart drawer's real element id is #cart-root (not #cart-drawer). */
    var overlayOpen =
      gateOpen ||
      !!document.querySelector(".wl-root.wl-open, .wl-root[data-open='1']") ||
      !!document.querySelector("#cart-root:not(.hidden)");

    if (!overlayOpen && document.body.style.overflow === "hidden") {
      document.body.style.overflow = "";
    }
  }

  function boot() {
    unstickScroll();
    killTouchParallax();
    gateAnimations();
    gateVisibility();
    markContainable();
  }

  window.addEventListener("pageshow", unstickScroll, { passive: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
